import React, {Component} from 'react';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {contactName: ''};
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit = (event) => {
        alert('I will contact you a soon as possible.\nThank you!');
        fetch('https://kuropatkin.dev/api/form', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            // We convert the React state to JSON and send it as the POST body
            body: JSON.stringify(this.state)
        }).then(function (response) {
            //console.log(response)
            window.location.reload();
            //return response.json();
        });
        event.preventDefault();

    }

    render() {
        if (this.props.data) {
            var message = this.props.data.contactmessage;
        }
        return (
            <section id="contact">

                <div className="row section-head">

                    <div className="two columns header-col">

                        <h1><span>Contact</span></h1>

                    </div>

                    <div className="ten columns">

                        <p className="lead">{message}</p>

                    </div>

                </div>

                <div className="row">
                    <div className="eight columns">

                        <form onSubmit={this.handleSubmit}>
                            <fieldset>
                                <div>
                                    <label htmlFor="contactName">Name <span className="required">*</span></label>
                                    <input type="text" value={this.state.value} name="contactName"
                                           onChange={this.handleChange}/>
                                </div>

                                <div>
                                    <label htmlFor="contactEmail">Email <span className="required">*</span></label>
                                    <input type="text" defaultValue="" size="35" id="contactEmail" name="contactEmail"
                                           onChange={this.handleChange}/>
                                </div>

                                <div>
                                    <label htmlFor="contactSubject">Subject</label>
                                    <input type="text" defaultValue="" size="35" id="contactSubject"
                                           name="contactSubject" onChange={this.handleChange}/>
                                </div>

                                <div>
                                    <label htmlFor="contactMessage">Message <span className="required">*</span></label>
                                    <textarea cols="50" rows="15" id="contactMessage" name="contactMessage"
                                              onChange={this.handleChange}> </textarea>
                                </div>

                                <div>
                                    <button className="submit">Submit</button>
                                    <span id="image-loader">
                        <img alt="" src="images/loader.gif"/>
                     </span>
                                </div>
                            </fieldset>
                        </form>

                        <div id="message-warning"> Error</div>
                        <div id="message-success">
                            <i className="fa fa-check"></i>Your message was sent, thank you!<br/>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js